import styled from 'styled-components'
import { flex, TFlexParam } from '@hfs/ui/utils/style/flex'

export const View = styled.div<TFlexParam>`
  ${flex}
`
